import { IconButton, TableRow, TableCell, SxProps, Theme } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useCallback, MouseEvent as ReactMouseEvent } from 'react';
import { useQuoteState } from 'shared/contexts';
import { OrderNote } from 'shared/types';
import { formatDateTime } from 'shared/utility';

const orderNotesSummaryContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  cursor: 'pointer',
  '& .MuiTableCell-body': {
    '&:first-of-type': {
      paddingLeft: theme.spacing(5),
    },
  },
});

interface OrderNotesSummaryProps {
  orderNote: OrderNote;
  index: number;
  remove: (index?: number | number[] | undefined) => void;
}

export function OrderNotesSummary({ orderNote, index, remove }: OrderNotesSummaryProps) {
  const { editMode } = useQuoteState();

  const removeOrderNote = useCallback(
    (event: ReactMouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      remove(index);
    },
    [remove, index]
  );

  return (
    <>
      <TableRow sx={orderNotesSummaryContainerStyles}>
        <TableCell align='left'>{orderNote.note}</TableCell>
        <TableCell align='left'>{orderNote.createdBy}</TableCell>
        <TableCell align='left'>{formatDateTime(new Date(orderNote.creationDate))}</TableCell>
        <TableCell align='right'>
          {editMode && (
            <IconButton onClick={removeOrderNote}>
              <Delete />
            </IconButton>
          )}
        </TableCell>
      </TableRow>
    </>
  );
}
